import { queryApi } from "src/utils/api/ApiMethods"

export const queryDockageDeals = ({ page = 1, location }) => {
  const paramsObj = { page }

  if (location?.latitude && location?.longitude) {
    paramsObj.lat = location.latitude
    paramsObj.lon = location.longitude
  }

  const urlParams = new URLSearchParams(paramsObj)

  return queryApi(`/dockwa_deals?${urlParams.toString()}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}

export const queryFavorites = ({ page = 1 }) => {
  return queryApi(`/dockwa_deals/favorite_marinas?page=${page}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}

export const queryFuelDeals = ({ page = 1, location }) => {
  const paramsObj = { page }

  if (location?.latitude && location?.longitude) {
    paramsObj.lat = location.latitude
    paramsObj.lon = location.longitude
  }

  const urlParams = new URLSearchParams(paramsObj)

  return queryApi(`/dockwa_plus/fuel_discounts?${urlParams.toString()}`, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
}
